import type { IconData } from '@stacksjs/iconify-core'

export const sailShipSolid: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M21.527 1.984c1.69-1.359 3.973-.03 3.973 1.937V29.5H44c1.902 0 3.604 1.59 3.314 3.693c-.09.652-.224 1.43-.422 2.307H1.108a27 27 0 0 1-.422-2.307C.396 31.09 2.097 29.5 4 29.5h17.5v-3H10.854c-3.313 0-5.56-3.514-3.8-6.502c2.863-4.863 8.165-12.94 14.473-18.014M1.956 38.5c.346 1.02.775 2.104 1.306 3.226c1.39 2.936 4.402 4.477 7.422 4.563c3.382.097 8.408.211 13.316.211s9.933-.114 13.315-.211c3.02-.086 6.033-1.627 7.422-4.563c.531-1.122.96-2.207 1.306-3.226z\"/><path fill=\"currentColor\" d=\"M29.4 4.592a1.5 1.5 0 0 0-.9 1.375v19.05a1.5 1.5 0 0 0 1.5 1.5h7.814c3.257 0 5.496-3.4 3.905-6.386c-2.312-4.34-6.352-11.229-10.699-15.264a1.5 1.5 0 0 0-1.62-.275\"/>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default sailShipSolid
